import { normalizeDateOnly } from '@shared/libs/date-validation';

export const shouldShowTicketPresenceStatus = (eventDateStart?: string | null): boolean => {
  if (!eventDateStart) return true;

  const today = normalizeDateOnly(new Date());
  const eventStart = normalizeDateOnly(new Date(eventDateStart));

  return today >= eventStart;
};
